import { Component, OnInit } from '@angular/core';
import { DwMdSectionConfigBaseComponent2, DwComponentSectionConfigPreference, DwMdItem } from '@devwareapps/devware-cap';
import { FileExplorerConfig } from '../../models/file-explorer-config.model';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-file-explorer-config',
  templateUrl: './file-explorer-config.component.html',
  styleUrls: ['./file-explorer-config.component.scss']
})
export class FileExplorerConfigComponent
  extends  DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<FileExplorerConfig>> {

  configFormGroup: FormGroup;
  itemMetaData: DwMdItem;

  setupForm() {
    // Add config fields to the form

    this.configFormGroup = new FormGroup({
      attachmentId: new FormControl(),
    });

    this.formGroup.addControl('config', this.configFormGroup);

  }


  setupAttributeList() {
    this.getItemMetaData(this.itemName)
      .subscribe(itemMetaData => {
        this.itemMetaData = itemMetaData;
      });
  }

}
